:host {

}

.stzh-chipgroup {
  display: flex;
  gap: space('medium');
}
